import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../config/axiosConfig"; // Usa tu instancia de Axios configurada
import ENV from "../config/env";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("token"));
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axios.get("/api/auth/profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setUser(res.data);
      } catch (err) {
        console.error("Error al cargar el perfil:", err);
      }
    };

    fetchProfile();
  }, [isAuthenticated]);

  const setAuth = (token) => {
    setIsAuthenticated(!!token);
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
      setUser(null);
    }
  };

  const logout = async () => {
    // 1. borrar tokens/front
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    setIsAuthenticated(false);
    setUser(null);
    console.log(`${ENV.PHP_SORT_SERVIDOR}/files/logout.php`);
    // 2. avisar al PHP para que destruya la sesión
    try {
      await fetch(`${ENV.PHP_SORT_SERVIDOR}/files/logout.php`, {
        method: "POST",
        credentials: "include", // 👈 manda la cookie de sesión PHP
      });
    } catch (e) {
      console.warn("No se pudo cerrar sesión en PHP", e);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, setAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
